/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/settings.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISettingsMethods extends IPluginMethodMap {
  getSettingsProps(args: any): Promise<any>;
}

export class SettingsService implements IAgentPlugin {
  readonly methods: ISettingsMethods;

  constructor() {
    this.methods = {
      getSettingsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {},
            options: {
              limit: 100,
              skip: 0,
              sort: {
                order: "asc",
                field: "status",
              },
            },
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          const presentations = res?.data?.getPresentations?.content || [];
          const activePresentationId = presentations[0]?.id ?? "";

          const searchStatusFilter = presentations.map(
            (_item: any) => ({
              value: _item?.id,
              label: _item?.name,
            })
          );
          return {
            ...(config || {}),
            searchStatusFilter,
            activePresentationId,
          };
        }
      }
    } catch (err: any) {
      console.log("error fetching presentations in SettingsService", err);
    }
    return { ...(config || {}) };
  }
}
